import { ArrowRight, MessageCircle, Phone } from "lucide-react";
import { useConsultation } from "@/context/ConsultationContext";
import { useLanguage } from "@/i18n/LanguageContext";
import { PHONE_LINK, WA_LINK } from "@/data/content";
import { track } from "@/lib/api";

export const ConsultButton = ({ className = "", testid = "consult-cta-button", children }) => {
  const { setOpen } = useConsultation();
  const { t } = useLanguage();
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => { track("consult_cta_click"); setOpen(true); }}
      className={`group inline-flex items-center justify-center gap-2 rounded-full bg-gold px-7 py-3.5 text-sm font-bold text-charcoal shadow-[0_8px_30px_rgba(212,175,55,0.25)] transition-[background-color,transform] duration-300 hover:-translate-y-0.5 hover:bg-gold-soft ${className}`}
    >
      {children || t("cta.consult")}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
    </button>
  );
};

export const WhatsAppLink = ({ className = "", testid = "whatsapp-cta-button", children, message }) => {
  const { t } = useLanguage();
  return (
    <a
      href={WA_LINK(message)}
      target="_blank"
      rel="noreferrer"
      data-testid={testid}
      onClick={() => track("whatsapp_click")}
      className={`group inline-flex items-center justify-center gap-2 rounded-full border border-white/25 px-7 py-3.5 text-sm font-bold text-offwhite transition-[background-color,border-color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold hover:bg-white/5 ${className}`}
    >
      <MessageCircle className="h-4 w-4 text-gold" aria-hidden="true" />
      {children || t("cta.whatsapp")}
    </a>
  );
};

export const CallLink = ({ className = "", testid = "call-cta-button", children }) => {
  const { t } = useLanguage();
  return (
    <a
      href={PHONE_LINK}
      data-testid={testid}
      onClick={() => track("call_click")}
      className={`group inline-flex items-center justify-center gap-2 text-sm font-bold transition-colors hover:text-gold ${className}`}
    >
      <Phone className="h-4 w-4 text-gold" aria-hidden="true" />
      {children || t("cta.call")}
    </a>
  );
};
